var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DashboardHeader',{attrs:{"title":"Student Fees Switchboard 22"}},[_c('div',{staticClass:"mt-16"},[_c('DashboardTiles',{attrs:{"tiles":_vm.tiles}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }